// const endPoint = process.env.NODE_ENV === 'development' ? 'https://dev.atnbookingengine.com/api' : 'https://www.atnbookingengine.com/api'
// const endPointV2 = process.env.NODE_ENV === 'development' ? 'https://dev.atnbookingengine.com/v2/api' : 'https://www.atnbookingengine.com/v2/api'
const endPoint = 'https://dev.atnbookingengine.com/api'
const endPointV2 = 'https://dev.atnbookingengine.com/v2/api'
// app currency
export const currencies = `${endPoint}/getCurrencies`
// login
export const getUser = () => `${endPoint}/user/login`
// flights
export const getAirlines = (term) => `${endPointV2}/flights/airlines/autocomplete?term=${term}`
export const getAirports = (term) => `${endPoint}/airport/autocomplete?term=${term}`
export const searchFlights = (term) => `${endPoint}/flights/search?${term}`
export const getFlight = (id, search, relatedFlightId) => {
  if (relatedFlightId) return `${endPoint}/flights?flight_id=${id}&search_id=${search}&related_flight_id=${relatedFlightId}`
  else return `${endPoint}/flights?flight_id=${id}&search_id=${search}`
}
export const getServices = (flightID) => `${endPoint}/flights/service-catalog?flight_id=${flightID}`
export const getOffers = `${endPoint}/flights/service-list`
export const getSeats = `${endPoint}/flights/seat-map`
export const createPNR = `${endPoint}/pnr/create`
export const intentTK = `${endPoint}/pnr/intent-ticket`
export const issueTK = `${endPoint}/pnr/issue-ticket`
export const showPNR = (pnr) => `${endPoint}/pnr/${pnr}`
export const bookFlightByMail = `${endPointV2}/flights/send-special-offer-request-mail`

// cars
export const carSearch = (term) => `${endPoint}/cars/search?${term}`
export const showCar = (term) => `${endPoint}/cars/show?${term}`
export const rentCar = `${endPoint}/cars/book`

// hotels
export const getCities = (term) => `${endPoint}/cities/autocomplete?term=${term}`
export const searchHotels = (term) => `${endPoint}/hotels/search?${term}`
export const getHotel = (sessionId, hotelIndex, hotelCode) => `${endPoint}/hotels/show?sessionId=${sessionId}&hotelIndex=${hotelIndex}&hotelCode=${hotelCode}`
export const hotelAvailability = (term) => `${endPoint}/hotels/roomsAvailabilityAndPricing?${term}`
export const bookHotel = `${endPoint}/hotels/book`

// specialRquests

export const getspecialRequests = `${endPointV2}/flights/special-requests`
// headers
const correlationId = crypto.randomUUID()
export function headersNoAuth () {
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://tk-ndc.adamtravel.net', 'x-correlation-id': correlationId }
  return { Accept: 'application/json', 'Content-type': 'application/json', 'x-correlation-id': correlationId }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'http://localhost/tk' }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://tk-ndc.adamtravel.net' }
  // return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://sabre-ndc.adamtravel.net' }
}
export function headersAuth (token) {
  return {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'x-correlation-id': correlationId,
    Authorization: `Bearer${token}`
  }
}
export function headerNoCorr () {
  return { Accept: 'application/json', 'Content-type': 'application/json' }
}
